<div class="card-header bg-light">
  <h4 class="card-title mb-0">
    <i class="far fa-file"></i>
    {{ data.visualizar ? 'Visualizar' : 'Editar' }} Manifestação do Auditado
  </h4>
</div>

<div class="p-2 wrapper">
  <form [formGroup]="form">
    <div class="row">
      <div class="col-md-4 mb-2">
        <label class="form-label">Associado à</label>
        <input type="text"
               class="form-control form-control-sm"
               formControlName="numeroOsa"
               readonly>
      </div>

      <div class="col-md-4 mb-2">
        <label class="form-label">Prazo para Resposta <span class="text-danger">*</span></label>
        <input type="text"
               class="form-control form-control-sm"
               id="prazoResposta"
               formControlName="prazoResposta"
               placeholder="DD/MM/AAAA"
               bsDatepicker
               [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY' }"
               [disabled]="data.visualizar"
               [ngClass]="{ 'is-invalid': submitted && form.get('prazoResposta')?.invalid }" />

        <div *ngIf="submitted && form.get('prazoResposta')?.invalid" class="invalid-feedback d-block">
          <div *ngIf="form.get('prazoResposta')?.errors?.required">Campo obrigatório</div>
          <div *ngIf="form.get('prazoResposta')?.errors?.dataMenorHoje">Data não pode ser anterior a hoje</div>
        </div>
      </div>

      <div class="col-md-4 mb-2">
        <label class="form-label">Status</label>
        <input
          type="text"
          class="form-control form-control-sm"
          disabled
          [value]="getStatusManifestacaoDescricao(form.get('status')?.value)" />
      </div>
    </div>

    <!-- LINHA 2: Nome / Cargo -->
    <div class="row">
      <div class="col-md-6 mb-2">
        <label class="form-label">Nome do Responsável <span class="text-danger">*</span></label>
        <input type="text"
               class="form-control form-control-sm"
               formControlName="nomeResponsavel"
               maxlength="50"
               [readonly]="data.visualizar"
               [ngClass]="{ 'is-invalid': submitted && form.get('nomeResponsavel')?.invalid }" />
        <div *ngIf="submitted && form.get('nomeResponsavel')?.invalid" class="invalid-feedback d-block">
          <div *ngIf="form.get('nomeResponsavel')?.errors?.required">Campo obrigatório</div>
          <div *ngIf="form.get('nomeResponsavel')?.errors?.maxlength">Máximo 50 caracteres</div>
        </div>
      </div>

      <div class="col-md-6 mb-2">
        <label class="form-label">Cargo do Responsável <span class="text-danger">*</span></label>
        <input type="text"
               class="form-control form-control-sm"
               formControlName="cargoResponsavel"
               maxlength="50"
               [readonly]="data.visualizar"
               [ngClass]="{ 'is-invalid': submitted && form.get('cargoResponsavel')?.invalid }" />
        <div *ngIf="submitted && form.get('cargoResponsavel')?.invalid" class="invalid-feedback d-block">
          <div *ngIf="form.get('cargoResponsavel')?.errors?.required">Campo obrigatório</div>
          <div *ngIf="form.get('cargoResponsavel')?.errors?.maxlength">Máximo 50 caracteres</div>
        </div>
      </div>
    </div>

    <!-- DESCRIÇÃO DO ENVIO (editor / visualização) -->
    <div class="col-md-12 mb-2">
      <label class="form-label">Descrição do Envio <span class="text-danger">*</span></label>

      <angular-editor
        *ngIf="!data.visualizar; else visualizarEnvio"
        [config]="config"
        formControlName="descricaoEnvio"
        [ngClass]="{ 'is-invalid': submitted && form.get('descricaoEnvio')?.invalid }">
      </angular-editor>

      <!-- Contador de caracteres -->
      <div class="d-flex justify-content-end mt-1" *ngIf="!data.visualizar">
        <small [ngClass]="{
      'text-danger': contarCaracteres(form.get('descricaoEnvio')?.value) >= EDITOR_MAX_CHARS,
      'text-muted':  contarCaracteres(form.get('descricaoEnvio')?.value) < EDITOR_MAX_CHARS
    }">
          {{ contarCaracteres(form.get('descricaoEnvio')?.value) }} / {{ EDITOR_MAX_CHARS }}
        </small>
      </div>

      <ng-template #visualizarEnvio>
        <div class="form-control visualizar-editor"
             [innerHTML]="form.get('descricaoEnvio')?.value">
        </div>
      </ng-template>

      <div *ngIf="submitted && form.get('descricaoEnvio')?.invalid" class="invalid-feedback d-block">
        <div *ngIf="form.get('descricaoEnvio')?.errors?.required">Campo obrigatório</div>
        <div *ngIf="form.get('descricaoEnvio')?.errors?.maxlength">Máximo 500 caracteres</div>
      </div>
    </div>

    <!-- ARQUIVOS ENVIADOS -->
    <div class="col-md-12 mb-2">
      <label class="form-label">Arquivos Enviados <span class="text-danger">*</span> (Min 1, Máx 28MB)</label>

      <div class="mat-elevation-z4">
        <table mat-table [dataSource]="dataSourceEnviados" matSort #sortEnviados="matSort" class="w-100"  matSortDisableClear>

          <tr mat-header-row *matHeaderRowDef="['arquivoEnviado', 'acoesEnviado']" class="bg-light"></tr>

          <!-- Coluna: Arquivo -->
          <ng-container matColumnDef="arquivoEnviado">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Título</th>
            <td mat-cell *matCellDef="let element">
              <small class="download" style="cursor: pointer;">
                {{ element?.nomeArquivo }}
              </small>
            </td>
          </ng-container>

          <!-- Coluna: Ações -->
          <ng-container matColumnDef="acoesEnviado">
            <th mat-header-cell *matHeaderCellDef class="text-right">

              <span *ngIf="!data.visualizar">
            <label for="fileEnviado" class="btn btn-success btn-xs mb-0">Adicionar</label>
            <input type="file"
             id="fileEnviado"
             #fileEnviado
             multiple="multiple"
             style="display: none"
             accept=".png,.jpg,.jpeg,.pdf,.xlsx,.mp4"
             (change)="adicionarArquivoEnviado($event)" />
    </span>
            </th>

            <td mat-cell *matCellDef="let element; let i = index" class="text-center">
              <button type="button"
                      class="btn btn-danger btn-xs mr-1"
                      *ngIf="!data.visualizar"
                      title="Excluir"
                      (click)="removerAnexoEviado(i, element)">
                <i class="far fa-trash-alt"></i>
              </button>

              <button type="button"
                      class="btn btn-info btn-xs"
                      (click)="download(element)"
                      title="Download">
                <i class="fas fa-download"></i>
              </button>
            </td>
          </ng-container>

          <tr mat-row *matRowDef="let row; columns: ['arquivoEnviado', 'acoesEnviado']"></tr>
        </table>

        <h5 [hidden]="dataSourceEnviados?.data?.length > 0" class="table-no-data">
          Nenhum anexo encontrado
        </h5>


        <mat-paginator #paginatorEnviados [pageSizeOptions]="[5, 10, 15]" showFirstLastButtons>
        </mat-paginator>
      </div>
      <div *ngIf="submitted && (!dataSourceEnviados?.data || dataSourceEnviados.data.length === 0)"
           class="invalid-feedback d-block mt-1">
        <div>É necessário anexar pelo menos um arquivo</div>
      </div>
      <div class="d-flex justify-content-end mt-2" *ngIf="podeExibirBotaoEnviar()">
        <button type="button"
                class="btn btn-success btn-sm"
                (click)="enviar()"
                [disabled]="loading">
          <i class="fas fa-paper-plane"></i> Enviar
        </button>
      </div>
    </div>

    <!-- DESCRIÇÃO MANIFESTAÇÃO RECEBIDA -->
    <div class="col-md-12 mb-2">
      <label class="form-label">
        Descrição da Manifestação Recebida
        <span class="text-danger" *ngIf="form.get('status')?.value === StatusManifestacao.Enviado">*</span>
      </label>

      <angular-editor
        *ngIf="!data.visualizar; else visualizarRecebida"
        [config]="config"
        formControlName="descricaoManifestacao"
        [ngClass]="{ 'is-invalid': submitted && form.get('descricaoManifestacao')?.invalid }">
      </angular-editor>

      <!-- Contador de caracteres -->
      <div class="d-flex justify-content-end mt-1" *ngIf="!data.visualizar">
        <small [ngClass]="{
      'text-danger': contarCaracteres(form.get('descricaoManifestacao')?.value) >= EDITOR_MAX_CHARS,
      'text-muted':  contarCaracteres(form.get('descricaoManifestacao')?.value) < EDITOR_MAX_CHARS
    }">
          {{ contarCaracteres(form.get('descricaoManifestacao')?.value) }} / {{ EDITOR_MAX_CHARS }}
        </small>
      </div>

      <ng-template #visualizarRecebida>
        <div class="form-control visualizar-editor"
             [innerHTML]="form.get('descricaoManifestacao')?.value">
        </div>
      </ng-template>

      <div *ngIf="submitted
      && form.get('descricaoManifestacao')?.invalid
      && form.get('status')?.value === 3"
           class="invalid-feedback d-block">
        <div *ngIf="form.get('descricaoManifestacao')?.errors?.required">Campo obrigatório</div>
        <div *ngIf="form.get('descricaoManifestacao')?.errors?.maxlength">Máximo 500 caracteres</div>
      </div>
    </div>

    <!-- ARQUIVOS RECEBIDOS -->
    <div class="col-md-12 mb-2">
      <label class="form-label">Arquivos Recebidos (Máx 28MB)</label>

      <div class="mat-elevation-z4">
        <table mat-table [dataSource]="dataSourceRecebidos" class="w-100" matSort #sortRecebidos="matSort" matSortDisableClear>

          <tr mat-header-row *matHeaderRowDef="['arquivoRecebido', 'acoesRecebido']" class="bg-light"></tr>

          <!-- Coluna: Arquivo -->
          <ng-container matColumnDef="arquivoRecebido">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Título</th>
            <td mat-cell *matCellDef="let element">
              <small class="download" style="cursor: pointer;">
                {{ element?.nomeArquivo }}
              </small>
            </td>
          </ng-container>

          <!-- Coluna: Ações -->
          <ng-container matColumnDef="acoesRecebido">
            <th mat-header-cell *matHeaderCellDef class="text-right">
        <span *ngIf="!data.visualizar">
          <label for="fileRecebido" class="btn btn-success btn-xs mb-0">Adicionar</label>
          <input type="file"
                 id="fileRecebido"
                 #fileRecebido
                 multiple="multiple"
                 style="display: none"
                 accept=".png,.jpg,.jpeg,.pdf,.xlsx,.mp4"
                 (change)="adicionarArquivoRecebido($event)" />
        </span>
            </th>

            <td mat-cell *matCellDef="let element; let i = index" class="text-center">
              <button
                type="button"
                class="btn btn-danger btn-xs mr-1"
                *ngIf="!data.visualizar"
                title="Excluir"
                (click)="removerAnexoRecebido(i, element)">
                <i class="far fa-trash-alt"></i>
              </button>

              <button type="button"
                      class="btn btn-info btn-xs"
                      (click)="downloadRecebido(element)")
                      title="Download">
                <i class="fas fa-download"></i>
              </button>
            </td>
          </ng-container>
          <tr mat-row *matRowDef="let row; columns: ['arquivoRecebido', 'acoesRecebido']"></tr>
        </table>

        <h5 [hidden]="dataSourceRecebidos?.data?.length > 0" class="table-no-data">
          Nenhum anexo encontrado
        </h5>

        <mat-paginator #paginatorRecebidos [pageSizeOptions]="[5, 10, 15]" showFirstLastButtons>
        </mat-paginator>
      </div>
      <div *ngIf="submitted
              && form.get('status')?.value === 3
              && (!dataSourceRecebidos?.data || dataSourceRecebidos.data.length === 0)"
                     class="invalid-feedback d-block mt-1">
        <div>É necessário anexar pelo menos um arquivo recebido</div>
      </div>
    </div>

  </form>
</div>

<!-- FOOTER PADRÃO -->
<div class="card-footer">
  <div class="d-flex w-100 justify-content-between align-items-center">
    <div class="list2">
      <button type="button" class="btn btn-default btn-sm mr-1" (click)="fechar()">
        <i class="fas fa-times"></i> Fechar
      </button>
    </div>

    <div class="list1">
      <button type="button"
              class="btn btn-success btn-sm mr-1"
              (click)="avaliar()"
              *ngIf="podeAvaliar()"
              [disabled]="loading">
        <i class="fas fa-check"></i> Avaliar
      </button>

      <button type="button"
              class="btn btn-primary btn-sm mr-1"
              (click)="salvar()"
              [hidden]="data.visualizar && manifestacao?.id"
              [disabled]="loading">
        <i class="far fa-save"></i> Salvar
      </button>
    </div>
  </div>
</div>
